import { createRouter, createWebHashHistory } from "vue-router";
import User from "../js/user";
import req from "../js/req";
import config from "../js/config";
const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "home",
    meta: {
      show_nav_back: false,
      nav_title: "阳光打卡",
      show_tabbar: true,
      tab_index: 0,
    },
    component: () => import("../views/home"),
  },
  {
    path: "/square",
    name: "square",
    meta: {
      show_nav_back: false,
      nav_title: "广场",
      show_tabbar: true,
      tab_index: 1,
    },
    component: () => import("../views/square"),
  },
  {
    path: "/notice",
    name: "notice",
    meta: {
      show_nav_back: false,
      nav_title: "公告",
      show_tabbar: true,
      tab_index: 2,
    },
    component: () => import("../views/notice"),
  },
  {
    path: "/notice-detail",
    name: "notice-detail",
    meta: {
      show_nav_back: false,
      show_tabbar: false,
    },
    component: () => import("../views/notice/detail"),
  },
  {
    path: "/mine",
    name: "mine",
    meta: {
      show_nav_back: false,
      nav_title: "我的",
      show_tabbar: true,
      tab_index: 3,
    },
    component: () => import("../views/mine"),
  },
  {
    path: "/message-detail",
    name: "消息详情",
    meta: { show_nav_back: true, nav_title: "消息详情", show_tabbar: false },
    component: () => import("../views/mine/message-detail"),
  },
  {
    path: "/sport-check-in",
    name: "体育打卡提交",
    meta: {
      show_nav_back: true,
      nav_title: "体育活动打卡",
      show_tabbar: false,
    },
    component: () => import("../views/home/check-in"),
  },
  {
    path: "/art-check-in",
    name: "艺术打卡提交",
    meta: {
      show_nav_back: true,
      nav_title: "艺术活动打卡",
      show_tabbar: false,
    },
    component: () => import("../views/home/art-check-in"),
  },
  {
    path: "/check-detail",
    name: "打卡详情",
    meta: { show_nav_back: true, nav_title: "打卡详情", show_tabbar: false },
    component: () => import("../views/check-detail"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const href = window.location.href;
  if (User.isLogin()) {
    //兼容之前的用户
    console.log(
      "User.getIsLoaded():",
      User.getIsLoaded(),
      User.getIsLoaded() != 1
    );
    if (User.getIsLoaded() != 1) {
      User.loginOut();
      User.setIsLoaded();
      const env = process.env.NODE_ENV;
      let local_path = "";
      if (env === "development") {
        local_path = encodeURIComponent(
          `${config.front_base}#/home`
        );
      } else {
        local_path = encodeURIComponent(`${config.front_base}/#/home`);
      }
      const loginPath = `https://app.buaa.edu.cn/uc/api/oauth/index?redirect=${local_path}&appid=200230221144501510&state=STATE&qrcode=1`;
      window.location.replace(loginPath);
    } else {
      next();
    }
  } else {
    if (href.includes("code=")) {
      User.setIsLoaded();
      const code = href.split("?")[1].split("&")[0].split("=").pop();
      startLoginIn(code, next);
    } else {
      const env = process.env.NODE_ENV;
      let local_path = "";

      if (env === "development") {
        local_path = encodeURIComponent(
          `${config.front_base}#/home`
        );
      } else {
        local_path = encodeURIComponent(`${config.front_base}#/home`);
      }
      const loginPath = `https://app.buaa.edu.cn/uc/api/oauth/index?redirect=${local_path}&appid=200230221144501510&state=STATE&qrcode=1`;
      window.location.replace(loginPath);
    }
  }
});
const startLoginIn = async (code, next) => {
  let data = await req.get(req.path.campusAppLogin, { code: code });
  User.setUT(data.uid, data.token);
  User.setUserInfo(data.user_info);
  User.getInstance().updateUnreadMessageCount();
  User.getInstance().updateUnreadNoticeCount();
  next({ path: "/", replace: true });
};
export default router;
